import { render, staticRenderFns } from "./LoginBox2024.vue?vue&type=template&id=aa191fa4&scoped=true&"
import script from "./LoginBox2024.vue?vue&type=script&lang=js&"
export * from "./LoginBox2024.vue?vue&type=script&lang=js&"
import style0 from "./LoginBox2024.vue?vue&type=style&index=0&id=aa191fa4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa191fa4",
  null
  
)

export default component.exports